'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _FeyeTimelineDate = require('./FeyeTimelineDate');

var _FeyeTimelineDate2 = _interopRequireDefault(_FeyeTimelineDate);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _find = require('lodash-compat/collection/find');

var _find2 = _interopRequireDefault(_find);

var _createChainedFunction = require('../utils/createChainedFunction');

var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);

var _ValidComponentChildren = require('../utils/ValidComponentChildren');

var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);

var _warning = require('warning');

var _warning2 = _interopRequireDefault(_warning);

var _reactMeasure = require('react-measure');

var _reactMeasure2 = _interopRequireDefault(_reactMeasure);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MENUITEM_ROLE = _FeyeTimelineDate2.default.defaultProps.bsRole;

var FeyeTimeline = function (_React$Component) {
  _inherits(FeyeTimeline, _React$Component);

  function FeyeTimeline(props) {
    _classCallCheck(this, FeyeTimeline);

    var _this = _possibleConstructorReturn(this, (FeyeTimeline.__proto__ || Object.getPrototypeOf(FeyeTimeline)).call(this, props));

    _this.extractChildren = _this.extractChildren.bind(_this);
    _this.refineMenuItem = _this.refineMenuItem.bind(_this);
    _this.onChangeWrapperWidth = _this.onChangeWrapperWidth.bind(_this);
    _this.state = {
      totalCount: 1,
      divisor: 1
    };
    _this.childExtractors = [{
      key: 'timelineDate',
      matches: function matches(child) {
        return child.props.bsRole === MENUITEM_ROLE;
      },
      refine: _this.refineMenuItem
    }];
    return _this;
  }

  _createClass(FeyeTimeline, [{
    key: 'extractChildren',
    value: function extractChildren() {
      var _this2 = this;

      var seen = {};
      this.incrementer = 0;
      var otherChildren = [];
      var children = _ValidComponentChildren2.default.map(this.props.children, function (child) {
        var extractor = (0, _find2.default)(_this2.childExtractors, function (x) {
          return x.matches(child);
        });

        if (extractor) {
          if (seen[extractor.key]) {
            return false;
          }
          seen[extractor.key] = extractor.exclusive;
          return extractor.refine(child);
        }
        otherChildren.push(child);
        return;
      });
      if (this.state.totalCount !== this.incrementer) {
        this.setState({
          totalCount: this.incrementer
        });
      }
      return [children, otherChildren];
    }
  }, {
    key: 'refineMenuItem',
    value: function refineMenuItem(menu) {
      this.incrementer = this.incrementer + 1;
      var menuProps = {
        totalCount: this.state.totalCount,
        keyIndex: this.incrementer,
        divisor: this.state.divisor
      };
      return (0, _react.cloneElement)(menu, menuProps, menu.props.children);
    }
  }, {
    key: 'onChangeWrapperWidth',
    value: function onChangeWrapperWidth() {
      var tw = this.wrapper.offsetWidth;
      var nw = tw / this.props.optimalNodeWidth;
      var divisor = this.incrementer / nw;
      this.setState({
        divisor: Math.ceil(divisor)
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var children = this.extractChildren();
      return _react2.default.createElement(
        'div',
        { className: 'fe-timeline fe-timeline--horizontal' },
        children[1],
        _react2.default.createElement(
          _reactMeasure2.default,
          { onMeasure: this.onChangeWrapperWidth },
          _react2.default.createElement(
            'div',
            { className: 'fe-timeline__wrapper', ref: function ref(_ref) {
                return _this3.wrapper = _ref;
              } },
            children[0]
          )
        )
      );
    }
  }]);

  return FeyeTimeline;
}(_react2.default.Component);

FeyeTimeline.propTypes = {
  optimalNodeView: _propTypes2.default.boolean,
  optimalNodeWidth: _propTypes2.default.number
};

FeyeTimeline.defaultProps = {
  optimalNodeView: false,
  optimalNodeWidth: 60
};

exports.default = FeyeTimeline;